import { type IntlShape } from 'react-intl';

import getUserRecommendations from '@atlaskit/smart-user-picker/recommendation-client';

type ProductKeyType = 'confluence' | 'jira' | 'loom';

type GetLastUpdatedByProps = {
	query: string;
	userId: string;
	cloudId: string;
	productKey: ProductKeyType;
	maxNumberOfResults: number;
	intl: IntlShape;
};

export const getLastUpdatedBy: ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetLastUpdatedByProps) => Promise<import('@atlaskit/user-picker').OptionData[]> = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetLastUpdatedByProps) => {
	const requestParams = {
		context: {
			contextType: 'lastUpdatedBy',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
